import React from "react";

export default function BsImage() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#f)" fill="#currentColor">
        <path d="M9.003 8.332a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z" />
        <path d="M3.003 1.582a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-15a3 3 0 0 0-3-3h-18Zm18 1.5a1.5 1.5 0 0 1 1.5 1.5v9.75l-5.666-2.92a.75.75 0 0 0-.865.139l-5.565 5.565-3.99-2.658a.75.75 0 0 0-.945.093l-3.97 3.531v-13.5a1.5 1.5 0 0 1 1.5-1.5h18Z" />
      </g>
      <defs>
        <clipPath id="f">
          <path fill="#fff" transform="translate(0 .082)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
